require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./news-ln-9-n-0-c-lkw-zde-csz-htc-f-16.json") })
        }
      }, "path---news-ln-9-n-0-c-lkw-zde-csz-htc-f-16");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---news-ln-9-n-0-c-lkw-zde-csz-htc-f-16!./.cache/json/news-ln-9-n-0-c-lkw-zde-csz-htc-f-16.json
// module id = ./node_modules/gatsby-module-loader/index.js?name=path---news-ln-9-n-0-c-lkw-zde-csz-htc-f-16!./.cache/json/news-ln-9-n-0-c-lkw-zde-csz-htc-f-16.json
// module chunks = 231608221292675